
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/pla-estrategic",
      function () {
        return require("private-next-pages/corporatiu/pla-estrategic/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/pla-estrategic"])
      });
    }
  